module.exports = __webpack_public_path__ + "img/turkiye-is-bankasi-isbox-kinect-03.07e5da23.jpg";